// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal CSS */

.ceaKpiModal {
    max-width: 40rem !important;
}

.ceaKpiModal-toyota .modal-dialog, .ceaKpiModal-toyota .modal-content {
    border-radius: 24px !important;
    border: 1px solid #e50000 !important;
}

.ceaKpiModal-lexus .modal-dialog, .ceaKpiModal-lexus .modal-content {
    border-radius: 24px !important;
    border: 1px solid #252525 !important;
}

.ceaKpiModal-toyota .modal-header {
    background-color: #e50000;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.ceaKpiModal-lexus .modal-header {
    background-color: #252525;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.modal-title {
    color: white;
    font-size: 1.0rem !important;
    padding-left: 0.5rem;
}

.modal-header .close {
    color: white;
    padding: 1.5rem !important;
    margin: -1.3rem -1rem -2rem auto !important;
}

.redFont {
    color: #e50000;
}

.ceaKpiModal-toyota .css-10nd86i svg {
    color: #e50000;
}

.ceaKpiModal-lexus .css-10nd86i svg {
    color: #252525;
}

.ceaKpiModal .css-10nd86i .css-1492t68 {
    text-indent: -9999px;
}

.ceaKpiModal .css-va7pk8 {
    color: #595d60 !important;
}

.modal-body {
    font-size: 0.81rem;
    color: #595d60;
    padding: 0.7rem !important;
}

.ceakpi_modal_unit{
    width: 33%;
}

.ceaKpiModal .card-header{
    cursor: pointer;
}


.parameterTable .react-bootstrap-table-editing-cell {
    padding-top: 5px!important;
    padding-bottom: 2px!important;
}

.parameterTable .react-bootstrap-table-editing-cell>input {
    padding-top: 3px!important;
    padding-bottom: 3px!important;
    height: 30px;
}


.parameterTable .react-bootstrap-table th[data-row-selection] {
    width: 90px;
}

.parameterTable .form-control {
   
    height: 30px;
  }

.addParam-toyota {
    background-color: white;
    border: 1px solid #e50000;
    color: #e50000;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 1.25rem;
    height: 1.8rem;
    padding: 0rem 10px;
  }
  
.addParam-lexus {
    background-color: white;
    border: 1px solid #252525;
    color: #252525;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 1.25rem;
    height: 1.8rem;
    padding: 0rem 10px;
  }


  .parameterTable .react-bootstrap-table-editing-cell>select {
    padding-top: 3px!important;
    padding-bottom: 3px!important;
    height: 30px;
}

.parameter_select {
    /* padding-top: 3px!important;
    padding-bottom: 3px!important; */
    height: 30px;
    width: 100%;
    /* height: 1.8rem; */
    /* border-color: 1px solid #dee2e6; */
    padding-top: 3px!important;
    padding-bottom: 3px!important;
    border: 1px solid #ced4da

}

`, "",{"version":3,"sources":["webpack://./src/components/ceaNetKpiModal/index.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,2CAA2C;AAC/C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,YAAY;AAChB;;;AAGA;IACI,WAAW;AACf;;AAEA;;IAEI,YAAY;EACd;;AAEF;IACI,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,kBAAkB;EACpB;;AAEF;IACI,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,kBAAkB;EACpB;;;EAGA;IACE,0BAA0B;IAC1B,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI;oCACgC;IAChC,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,qCAAqC;IACrC,0BAA0B;IAC1B,6BAA6B;IAC7B;;AAEJ","sourcesContent":["/* Modal CSS */\n\n.ceaKpiModal {\n    max-width: 40rem !important;\n}\n\n.ceaKpiModal-toyota .modal-dialog, .ceaKpiModal-toyota .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #e50000 !important;\n}\n\n.ceaKpiModal-lexus .modal-dialog, .ceaKpiModal-lexus .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #252525 !important;\n}\n\n.ceaKpiModal-toyota .modal-header {\n    background-color: #e50000;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.ceaKpiModal-lexus .modal-header {\n    background-color: #252525;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.modal-title {\n    color: white;\n    font-size: 1.0rem !important;\n    padding-left: 0.5rem;\n}\n\n.modal-header .close {\n    color: white;\n    padding: 1.5rem !important;\n    margin: -1.3rem -1rem -2rem auto !important;\n}\n\n.redFont {\n    color: #e50000;\n}\n\n.ceaKpiModal-toyota .css-10nd86i svg {\n    color: #e50000;\n}\n\n.ceaKpiModal-lexus .css-10nd86i svg {\n    color: #252525;\n}\n\n.ceaKpiModal .css-10nd86i .css-1492t68 {\n    text-indent: -9999px;\n}\n\n.ceaKpiModal .css-va7pk8 {\n    color: #595d60 !important;\n}\n\n.modal-body {\n    font-size: 0.81rem;\n    color: #595d60;\n    padding: 0.7rem !important;\n}\n\n.ceakpi_modal_unit{\n    width: 33%;\n}\n\n.ceaKpiModal .card-header{\n    cursor: pointer;\n}\n\n\n.parameterTable .react-bootstrap-table-editing-cell {\n    padding-top: 5px!important;\n    padding-bottom: 2px!important;\n}\n\n.parameterTable .react-bootstrap-table-editing-cell>input {\n    padding-top: 3px!important;\n    padding-bottom: 3px!important;\n    height: 30px;\n}\n\n\n.parameterTable .react-bootstrap-table th[data-row-selection] {\n    width: 90px;\n}\n\n.parameterTable .form-control {\n   \n    height: 30px;\n  }\n\n.addParam-toyota {\n    background-color: white;\n    border: 1px solid #e50000;\n    color: #e50000;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    margin: 4px 2px;\n    cursor: pointer;\n    border-radius: 1.25rem;\n    height: 1.8rem;\n    padding: 0rem 10px;\n  }\n  \n.addParam-lexus {\n    background-color: white;\n    border: 1px solid #252525;\n    color: #252525;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    margin: 4px 2px;\n    cursor: pointer;\n    border-radius: 1.25rem;\n    height: 1.8rem;\n    padding: 0rem 10px;\n  }\n\n\n  .parameterTable .react-bootstrap-table-editing-cell>select {\n    padding-top: 3px!important;\n    padding-bottom: 3px!important;\n    height: 30px;\n}\n\n.parameter_select {\n    /* padding-top: 3px!important;\n    padding-bottom: 3px!important; */\n    height: 30px;\n    width: 100%;\n    /* height: 1.8rem; */\n    /* border-color: 1px solid #dee2e6; */\n    padding-top: 3px!important;\n    padding-bottom: 3px!important;\n    border: 1px solid #ced4da\n\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
